import { logClientError } from '@utils/server-log';
/**
 * Classificação de RPCs quanto à necessidade de credencial.
 *
 * Existe porque o mesmo client gRPC (e o mesmo interceptor) atende tanto as
 * chamadas do login quanto as do painel autenticado. Sem essa separação não dá
 * para abortar uma request sem token: bloquear tudo derrubaria o próprio login.
 */

/** RPCs que rodam antes de existir sessão — as únicas que podem sair sem `Authorization`. */
const PUBLIC_RPC_METHODS = new Set([
  'Login',
  'LoginOAuth',
  'LoginOTP',
  'ValidateLoginOTP',
  'ValidateCodeOAuth',
  'ValidateMFA',
  'ResendValidationCodeChallenge',
  'SignUp',
  'ForgotMyPassword',
  'ResetMyPassword',
  'CheckToken',
  // RefreshToken e Logout carregam o refresh token no corpo da mensagem.
  'RefreshToken',
  'Logout',
]);

/** Extrai `Metodo` de um descritor no formato `/pacote.v1.Servico/Metodo`. */
export function getRpcMethodName(request: any): string {
  try {
    const fullName: string = request?.getMethodDescriptor?.()?.getName?.() ?? '';
    return fullName.substring(fullName.lastIndexOf('/') + 1);
  } catch {
    return '';
  }
}

/**
 * Decide se a chamada exige credencial válida.
 *
 * Método não identificado cai como público de propósito: manter o
 * comportamento antigo (request sem header) é ruim, mas travar um login por
 * causa de um descritor ilegível é pior.
 */
export function requiresAuthentication(request: any): boolean {
  const method = getRpcMethodName(request);

  if (!method) {
    logClientError('[gRPC] Método não identificado no descritor; tratando como RPC pública.');
    return false;
  }

  return !PUBLIC_RPC_METHODS.has(method);
}
